import { useEffect, useState } from 'react';

export function useSquadMembership(squadDetails, attendeeUuid) {
  const [isUserInSquad, setIsUserInSquad] = useState(false);
  const [isHost, setIsHost] = useState(false);

  useEffect(() => {
    // Check if we have all required data
    if (!squadDetails || !attendeeUuid || !squadDetails.members) {
      setIsUserInSquad(false);
      setIsHost(false);
      return;
    }

    // Try to find user by UUID first
    let userMember = squadDetails.members.find(
      (member) => member.attendee_uuid && member.attendee_uuid === attendeeUuid
    );

    // Fallback: if UUID match fails and we have a stored name, try matching by name
    if (!userMember) {
      const storedName = localStorage.getItem('attendee_name');
      if (storedName) {
        userMember = squadDetails.members.find(
          (member) => member.attendee_name === storedName
        );
      }
    }

    const userInSquad = !!userMember;
    setIsUserInSquad(userInSquad);
    setIsHost(userMember?.is_host === true);
    
    // Store attendee name if found and not already stored
    if (userMember && !localStorage.getItem('attendee_name')) {
      localStorage.setItem('attendee_name', userMember.attendee_name);
    }
  }, [squadDetails, attendeeUuid]);

  return { isUserInSquad, isHost };
}
